module.exports = __webpack_public_path__ + "media/sharing_success/robot_success-32b7ea22.png";